import styled from "styled-components";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

const StyledTabBar = styled.div`
	height: 30px;
	width: 100%;
	display: flex;
	overflow: auto;
	font-size: 11px;
	font-weight: 600;



    ${({ disabled }) => disabled === true && `
		pointer-events: none;
		user-select: none;
    `}
`;

const TabItem = styled(Link)`
	display: block;
	padding-left: 10px;
	padding-right: 10px;
	height: 100%;
	padding-top: 8px;

	text-decoration: none;

	&:focus, &:visited, &:link, &:active {
		text-decoration: none;
	}
	&:hover {
		text-decoration: none;
		background-color: ${(props) => !props.disabled && props.theme.color.disabledgray};
		border-radius: 5px;
	}
    :active {
        transform: translate(0, -1px);
    }

	color: ${(props) => props.disabled ? props.theme.color.disabledgray : props.theme.color.gray};
`;

const SelectedTabItem = styled(Link)`
	display: block;
	color: ${(props) => props.theme.color.dark};
	padding-left: 10px;
	padding-right: 10px;
	padding-top: 8px;
	height: 100%;
	font-weight: 700;
	background-color: white;
	border-radius: 5px 5px 0 0;

	text-decoration: none;

	&:focus, &:hover, &:visited, &:link, &:active {
		text-decoration: none;
	}
    :active {
        transform: translate(0, -1px);
    }
`;

function TabBar({tabs, defaultPath, selectedSubTabPath, disabled, ...restProps}) {
  
    return (
        <StyledTabBar disabled={disabled}>
			{tabs.map((tab, index) => {
				return selectedSubTabPath !== tab.path ? 
				<TabItem to={defaultPath + tab.path} key={index} disabled={disabled}>{tab.text}</TabItem> : 
				<SelectedTabItem to={defaultPath + tab.path} key={index}>{tab.text}</SelectedTabItem>;
			})}
		</StyledTabBar>
    )
}

TabBar.propTypes = {
    setPageTitle: PropTypes.func,
};

export default TabBar;